import { collection, doc, Firestore, getDoc, getDocs, getFirestore, runTransaction, serverTimestamp } from "firebase/firestore"
import { useFirebase } from "./firebase"
import { getCrockfordUUID } from "./uuid"

export function useVote() {
  const firebase = useFirebase()
  const firestore = getFirestore(firebase.app)

  const fnc = async (stall: string) => {
    await vote(firestore, stall)
  }

  return fnc
}

async function vote(firestore: Firestore, stall: string) {  
  let uid = localStorage.getItem("cosmosfair-2025-uid")
  if (uid) {
    const snapshot = await getDoc(doc(firestore, "votes", uid))
    if (!snapshot.exists()) {
      uid = null
    }
  }

  if (uid) {
    await runTransaction(firestore, async transaction => {
      transaction.update(doc(firestore, "votes_2025", uid!), {
        id: stall,
        update_at: serverTimestamp(),
      })
      transaction.set(doc(firestore, "vote_logs_2025", getCrockfordUUID()), {
        uid: uid,
        stall: stall,
        create_at: serverTimestamp(),
      })
    })
    console.log("Update vote", uid, stall)
  } else {
    uid = getCrockfordUUID()
    await runTransaction(firestore, async transaction => {
      transaction.set(doc(firestore, "votes_2025", uid!), {
        id: stall,
        create_at: serverTimestamp(),
        update_at: serverTimestamp(),
      })
      transaction.set(doc(firestore, "vote_logs_2025", getCrockfordUUID()), {
        uid: uid,
        stall: stall,
        create_at: serverTimestamp(),
      })
    })
    console.log("Create vote", uid, stall)
  }

  localStorage.setItem("cosmosfair-2025-uid", uid)
  localStorage.setItem("cosmosfair-2025-vote-stall", stall)
}

export function getVotedStall() {
  return localStorage.getItem("cosmosfair-2025-vote-stall") || undefined
}

export function isVotingPeriod() {
  const now = new Date()
  const start = new Date("2025-11-08T10:00:00+09:00")
  const end = new Date("2025-11-09T14:00:00+09:00")  
  return start <= now && now <= end
}

export async function calcVotingResult(firestore: Firestore) {
  const snapshot = await getDocs(collection(firestore, "votes_2025"))
  const votes = snapshot.docs.map(doc => doc.data())

  const resultDict: Record<string, number> = {}
  for (const vote of votes) {
    if (resultDict[vote.id] !== undefined) {
      resultDict[vote.id]! += 1
    } else {
      resultDict[vote.id] = 1
    }
  }

  const resultRecords = Object.entries(resultDict).map(([key, value]) => (
    {
      id: key,
      count: value
    }
  ))

  resultRecords.sort((record1, record2) => {
    if (record1.count !== record2.count) {
      return record2.count - record1.count;
    }
    return record1.id.localeCompare(record2.id);
  })

  return resultRecords
}